import { useRef } from 'react';
import type { HighwayMaintenanceFeeTicketSummary } from '#/components/ui/tickets/highway-maintenance-fee/model';

export type ChargeFailDialogConfirmValue = { afterDays: number };

export type ChargeFailDialogRef = {
  confirm: (
    ticket: HighwayMaintenanceFeeTicketSummary,
    amount: number,
  ) => Promise<ChargeFailDialogConfirmValue | undefined>;
  days: number | undefined;
};

export const useChargeFailDialog = () => {
  const modalRef = useRef<ChargeFailDialogRef>(null);
  const open = (ticket: HighwayMaintenanceFeeTicketSummary, amount: number) =>
    modalRef.current?.confirm(ticket, amount);
  return { props: { modalRef }, open };
};
